import useReveal from './useReveal';

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.49 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.34 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.4a16 16 0 0 0 5.55 5.55l.77-.77a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21 16.92z" />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const AvatarIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const team = [
  {
    name: 'Forster Maepa',
    role: 'Director',
    contacts: [
      { href: 'tel:0136500404', icon: <PhoneIcon />, label: '013 650 0404 / 013 650 0025' },
      { href: 'mailto:forster@fmmaepa.co.za', icon: <EmailIcon />, label: 'forster@fmmaepa.co.za' },
    ],
  },
  {
    name: 'Charles Mothoa',
    role: 'Senior Project Manager',
    contacts: [
      { href: 'tel:0733134873', icon: <PhoneIcon />, label: '073 313 4873 / 067 700 0764' },
    ],
  },
  {
    name: 'Vicky Mabilo',
    role: 'Manager',
    contacts: [
      { href: 'tel:0723640874', icon: <PhoneIcon />, label: '072 364 0874 / 067 117 5543' },
    ],
  },
];

export default function Team() {
  const hdrRef = useReveal();
  const gridRef = useReveal();

  return (
    <section id="team">
      <div className="team-hdr reveal" ref={hdrRef}>
        <div className="eyebrow">Our People</div>
        <h2 className="sec-title">The Team</h2>
        <p>
          At the core of F.M Maepa Engineering is a team of highly skilled professionals — Project
          Managers, Site Managers, Artisans, Fitters, Welders, and Boilermakers — all dedicated to
          precision and excellence.
        </p>
      </div>

      <div className="team-grid reveal" ref={gridRef}>
        {team.map(m => (
          <div className="team-card" key={m.name}>
            <div className="team-photo">
              <div className="team-av"><AvatarIcon /></div>
            </div>
            <div className="team-info">
              <h3>{m.name}</h3>
              <div className="team-role">{m.role}</div>
              <div className="team-contacts">
                {m.contacts.map(c => (
                  <a href={c.href} key={c.label}>{c.icon}{c.label}</a>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
